import * as React from "react";
import { useState, useRef, useEffect } from "react";
import clx from "clsx";
import Button from "../button";
import Icon from "../icon";
import { store } from "../../models/store";
import * as styles from "./connect-modal-head.css";
import { connectModalHeadTitleOverrides } from "./connect-modal-head.helper";
import type { ThemeVariant } from "../../models/system.model";
import type { OverrideStyleManager } from "../../styles/override/override";
import type { ConnectModalHeadProps } from "./connect-modal-head.types";

function ConnectModalHead(props: ConnectModalHeadProps) {
  const cleanupRef = useRef<() => void>(null);
  const [theme, setTheme] = useState(() => "light");

  const [overrideManager, setOverrideManager] = useState(() => null);

  useEffect(() => {
    setTheme(store.getState().theme);
    setOverrideManager(store.getState().overrideStyleManager);
    cleanupRef.current = store.subscribe((newState) => {
      setTheme(newState.theme);
      setOverrideManager(newState.overrideStyleManager);
    });
  }, []);

  useEffect(() => {
    return () => {
      if (typeof cleanupRef.current === "function") cleanupRef.current();
    };
  }, []);

  return (
    <div className={clx(styles.modalHeader, props.className)}>
      {props.hasBackButton ? (
        <div className={styles.modalBackButton}>
          <Button
            variant="ghost"
            intent="secondary"
            size="sm"
            onClick={(e) => {
              props.onBack?.(e);
            }}
            className={styles.headerButton}
          >
            <Icon name="arrowLeftSLine" size="$2xl" color="inherit" />
          </Button>
        </div>
      ) : null}
      <p
        id={props.id}
        style={overrideManager?.applyOverrides(
          connectModalHeadTitleOverrides.name
        )}
        {...props.titleProps}
        className={styles.modalHeaderText[theme]}
      >
        {props.title}
      </p>
      {props.hasCloseButton ? (
        <div className={styles.modalCloseButton}>
          <Button
            variant="ghost"
            intent="secondary"
            size="sm"
            domAttributes={props.closeButtonProps}
            onClick={(e) => props.closeButtonProps?.onClick?.(e)}
            className={styles.headerButton}
          >
            <Icon name="closeFilled" size="$2xl" color="inherit" />
          </Button>
        </div>
      ) : null}
    </div>
  );
}

ConnectModalHead.defaultProps = { hasBackButton: false, hasCloseButton: true };

export default ConnectModalHead;
